import PricingActionTypes from '../actionTypes/ProductPricingActionTypes';

const { PRODUCT_PRICING_GET_SUCCESS, UPDATE_PRODUCT_PRICING } = PricingActionTypes;

const ProductPricingReducer = function ProductPricingReducer(state = {}, action) {
    switch (action.type) {
        case PRODUCT_PRICING_GET_SUCCESS:
            return action.pricing;
        case UPDATE_PRODUCT_PRICING:
            return { ...state, ...action.payload };
        default: {
            return state;
        }
    }
};

ProductPricingReducer.reducerName = 'productOffering';

export default ProductPricingReducer;
